import { Outlet } from 'react-router-dom'
import { PostsProvider } from '@/components/common/posts/posts.provider'
import { posts } from '@/app/(site-officiel)/actualites/evenements/post-data'

export default function EvenementsLayout() {
  return (
    <PostsProvider storageKey="evenements_current_article" postsBasePath="/actualites/evenements" posts={posts}>
      <Outlet />
    </PostsProvider>
  )
}
